export const calcImgXPos = (canvasWidth, imgWidth) => {
  const imgXPos = (canvasWidth - imgWidth) / 2;
  return imgXPos;
};

export const calcImgYPos = (canvasHeight, imgHeight) => {
  const imgYPos = (canvasHeight - imgHeight) / 2;
  return imgYPos;
};
